import Script from 'next/script';

import { getDeviceAdId } from '@/utils/getDeviceAdId';

import { Keys, NetworkCallback, System } from '../index';

function registeredKeys() {
  return {
    UP: 38,
    DOWN: 40,
    LEFT: 37,
    RIGHT: 39,
    OK: 13,
    BACK: 10009,
    SELECT: 65376,
  };
}

enum SamsungNetworkStatus {
  INTERNET_CONNECTED = 0,
  LAN_CABLE_ATTACHED = 1,
  LAN_CABLE_DETACHED = 2,
  LAN_CABLE_STATE_UNKNOWN = 3,
  GATEWAY_CONNECTED = 4,
  GATEWAY_DISCONNECTED = 5,
  WIFI_MODULE_STATE_ATTACHED = 6,
  WIFI_MODULE_STATE_DETACHED = 7,
  WIFI_MODULE_STATE_UNKNOWN = 8,
  INTERNET_DISCONNECTED = 9,
}

const getDeepLinkId = () => {
  const requestedAppControl = (window as any)?.tizen?.application
    ?.getCurrentApplication()
    ?.getRequestedAppControl();

  if (requestedAppControl) {
    const appControlData = requestedAppControl?.appControl?.data;
    if (appControlData) {
      for (var i = 0; i < appControlData.length; i++) {
        if (appControlData[i].key == 'PAYLOAD') {
          const actionData = JSON.parse(appControlData[i].value[0]).values;

          return (
            JSON.parse(actionData)?.content_id ??
            JSON.parse(actionData)?.trailer_id ??
            actionData
          );
        }
      }
    }
  }
  return null;
};

export const system: System = {
  id: 'samsungtv',
  init: () => {
    console.log('Samsung System');

    (window as any)?.tizen?.tvinputdevice?.registerKeyBatch([
      'MediaPlayPause',
      'MediaRewind',
      'MediaFastForward',
      'MediaPlay',
      'MediaPause',
      'MediaStop',
    ]);
  },
  version: () => 'samsung.1.0.0',
  script: () => {
    return <Script strategy="beforeInteractive" src="$WEBAPIS/webapis/webapis.js" />;
  },
  keyThrottleDelay: 100,
  key: (keyboardEvent) => {
    const deviceKeys = registeredKeys();
    switch (keyboardEvent.keyCode) {
      case deviceKeys.UP:
        return Keys.UP;
      case deviceKeys.DOWN:
        return Keys.DOWN;
      case deviceKeys.LEFT:
        return Keys.LEFT;
      case deviceKeys.RIGHT:
        return Keys.RIGHT;
      case deviceKeys.OK:
        return Keys.OK;
      case deviceKeys.SELECT:
        return Keys.OK;
      case 27:
      case deviceKeys.BACK:
        return Keys.BACK;
      default:
        return Keys.UNKNOWN;
    }
  },

  getDeviceId: async () => {
    try {
      let productInfoAPI = (window as any).webapis?.productinfo;
      var value = productInfoAPI.getDuid();
      return value;
    } catch (error) {
      console.log('Failed to fetch Device Id');
    }
  },

  getErrorCodePrefix: () => 'A',
  closeApp: () => {
    (window as any)?.tizen?.application?.getCurrentApplication()?.exit();
  },
  getDeviceAdId: async () => {
    try {
      const id = (window as any)?.webapis?.adinfo?.getTIFA();
      return id ? id : getDeviceAdId();
    } catch (e) {
      return getDeviceAdId();
    }
  },
  getAdIdType: async () => {
    return 'tifa';
  },
  getIsLimitedAdTracking: async () => {
    try {
      return (window as any)?.webapis?.adinfo?.isLATEnabled() ?? true;
    } catch (e) {
      return true;
    }
  },
  monitorConnectionStatus: (callback: NetworkCallback) => {
    (window as any)?.webapis?.network?.addNetworkStateChangeListener((value: number) => {
      callback(
        value === (window as any)?.webapis?.network.NetworkState.GATEWAY_CONNECTED
      );
    });
  },
  hasPointer: false,
  initDeepLink: (handleDeepLink: (contentId: string) => void) => {
    const handleAppControl = () => {
      const contentId = getDeepLinkId();
      if (contentId) {
        handleDeepLink(contentId);
      }
    };

    document.addEventListener('appcontrol', handleAppControl);

    return () => {
      document.removeEventListener('appcontrol', handleAppControl);
    };
  },
  getDeepLinkId,
};
